/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Sidebar_Back_To_MenuInputs */

const en_layout_sidebar_back_to_menu = /** @type {(inputs: Layout_Sidebar_Back_To_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to menu`)
};

const pl_layout_sidebar_back_to_menu = /** @type {(inputs: Layout_Sidebar_Back_To_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do menu`)
};

/**
* | output |
* | --- |
* | "Back to menu" |
*
* @param {Layout_Sidebar_Back_To_MenuInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_sidebar_back_to_menu = /** @type {((inputs?: Layout_Sidebar_Back_To_MenuInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Sidebar_Back_To_MenuInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_sidebar_back_to_menu(inputs)
	return en_layout_sidebar_back_to_menu(inputs)
});